import { createFileRoute } from "@tanstack/react-router"
import { GovernanceVotingPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/governance/voting"
)({
  component: () => (
    <AuthorizationGate resource={Resource.GOVERNANCE} action={Action.READ}>
      <GovernanceVotingPage />
    </AuthorizationGate>
  ),
})
